module.exports = __webpack_public_path__ + "img/icon-close.8f12bf9b.svg";